import { render, staticRenderFns } from "./class-report.vue?vue&type=template&id=63c1505a&scoped=true&"
import script from "./class-report.vue?vue&type=script&lang=js&"
export * from "./class-report.vue?vue&type=script&lang=js&"
import style0 from "./class-report.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./class-report.vue?vue&type=style&index=1&id=63c1505a&lang=stylus&scoped=true&"
import style2 from "./class-report.vue?vue&type=style&index=2&id=63c1505a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1505a",
  null
  
)

export default component.exports